<div class="row align-items-end" *ngIf="!isUploadingDocuments">
  <div class="col-sm-6 text-center" *ngIf="!isGettingDriver">
    <div>
      <small id="driver-dates" class="text-muted">
        Creado: {{ driver.createdAt | dateFormat | dateWithoutSeconds }}<br />
        Actualizado: {{ driver.updatedAt | dateFormat | dateWithoutSeconds }}
      </small>
    </div>
    <div class="btn-group">
      <button
        id="driver-details-approve"
        type="button"
        class="btnApprove"
        (click)="onApproveDriver()"
        *ngIf="driverNeedsApproval && showButton('approve')"
      >
        Aprobar
      </button>
      <button
        id="driver-details-reject"
        type="button"
        class="btnDecline"
        style="padding-left: 10px"
        (click)="onRejectDriver()"
        *ngIf="driverCanBeRejected && showButton('reject')"
      >
        Rechazar
      </button>
    </div>
  </div>
  <div class="col-sm-6 text-end">
    <div class="btn-group" style="padding-top: 60px">
      <button
        id="driver-details-edit"
        type="button"
        class="btnApprove"
        *ngIf="!isGettingDriver && showButton('edit')"
        (click)="onEditDriver()"
      >
        Editar
      </button>
      <button
        id="driver-details-block"
        style="width: 115px"
        type="button"
        class="btnDelete btn-blocked-image btn-rectangle"
        (click)="onExcludeDriver()"
        *ngIf="!isGettingDriver && showButton('block')"
      >
        Bloquear
      </button>
      <button
        id="driver-details-block"
        style="width: 115px"
        type="button"
        class="btnActive btn-active-image btn-rectangle btnUnlock"
        (click)="onUnlockDriver()"
        *ngIf="!isGettingDriver && showButton('unlock')"
      >
        Desbloquear
      </button>
      <button
        id="driver-details-delete"
        type="button"
        class="btnDecline"
        (click)="onDeleteDriver()"
        *ngIf="!isGettingDriver && showButton('delete')"
      >
        Borrar
      </button>
      <button
        id="driver-details-refresh"
        class="btn btn-outline-secondary"
        style="border-radius: 30px"
        *ngIf="!isGettingDriver"
        (click)="onRefreshDriver()"
      >
        <span>
          <img
            ngSrc="assets/images/icons/actualizar.svg"
            height="25"
            width="25"
            alt="Actualizar"
          />
        </span>
      </button>
    </div>
  </div>
</div>
<div class="row mt-3" *ngIf="!isUploadingDocuments">
  <div class="col-sm-6 text-center my-5" *ngIf="isGettingDriver">
    <app-spinner message="Cargando detalles del conductor..."></app-spinner>
  </div>
  <div
    class="col-sm-6 box-details-cab"
    [ngStyle]="{ border: '3px solid ' + getColor() }"
    *ngIf="!isGettingDriver"
  >
    <div class="div-box-sap-id">
      <h4 [ngStyle]="{ color: getColor(), 'font-weight': 'bold' }">
        SAP ID: {{ driver.sapId! | sapId }}
      </h4>
    </div>
    <div style="display: inline">
      <p><strong>Transportista</strong>: <br />{{ driver.carrier!.name }}</p>
      <p><strong>RUT</strong>: <br />{{ driver.rut }}</p>
      <div class="divCenter" style="text-align: center">
        <p *ngIf="showBlockingMotives">
          <strong
            >Bloqueado el
            {{
              driver.lastStatusInformedAt || driver.updatedAt
                | dateFormat
                | dateWithoutSeconds
            }}
            por</strong
          >:<br />
          <span
            class="badge border rounded-4 text-bg-light mx-1"
            *ngFor="let motive of driver.blockingMotives"
          >
            {{ motive }}
          </span>
        </p>
      </div>
    </div>

    <div class="divCenter">
      <h5>
        <span
          class="badge"
          [ngStyle]="{ 'background-color': getColor() }"
          style="width: 200px; border-radius: 60px"
        >
          <span>
            <img
              [src]="getImageSrc(driver.status)"
              height="25"
              width="25"
              alt="Estado"
            />
          </span>
          {{ driver.status | master : "DRIVERS#STATUSES" }}</span
        >
      </h5>
      <div *ngIf="hasComment">
        <label
          class="custom-file-upload pt-2 mx-1 float-end text-secondary"
          style="cursor: pointer"
        >
          <a id="entity-comment" title="Comentario" (click)="onViewComment()">
            <span class="material-symbols-outlined">comment</span>
          </a>
        </label>
      </div>
    </div>
    <div class="divCenter mb-2" *ngIf="hasComment && showComment">
      <div class="collapse comment" [ngClass]="showCommentClass()">
        <div class="card card-body">
          {{ driver.comment }}
        </div>
      </div>
    </div>

    <div class="divCenter">
      <h6>
        <span
          class="badge border rounded-4 text-bg-light"
          *ngIf="hasToExpireDocuments()"
        >
          <span class="badge border rounded-circle text-bg-light">{{
            driver.documentsToExpire
          }}</span>
          por vencer</span
        >
      </h6>
      <h6>
        <span
          class="badge border rounded-4 text-bg-light"
          *ngIf="hasExpiredDocuments()"
        >
          <span class="badge border rounded-circle text-bg-light">{{
            driver.documentsExpired
          }}</span>
          vencido</span
        >
      </h6>
    </div>

    <div ngbAccordion style="padding: 10px">
      <div ngbAccordionItem [collapsed]="true">
        <h2 ngbAccordionHeader>
          <button id="driver-details-accordion" ngbAccordionButton>
            Ver detalles
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody class="table-container">
            <ng-template>
              <table class="table table-hover">
                <caption>
                  Detalles del Conductor
                </caption>
                <tbody>
                  <tr>
                    <th scope="row">Centro</th>
                    <td>{{ driver.originalCenter! | master : "CENTERS" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Nombre</th>
                    <td>{{ driver.firstName }} {{ driver.lastName }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Correo</th>
                    <td>{{ driver.email }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Teléfono</th>
                    <td>{{ driver.phone | phone }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Fecha de Nacimiento</th>
                    <td>{{ driver.birthDate }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Edad</th>
                    <td [ngClass]="driverAgeClass()">
                      {{ driverAge || 0 }} años
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Centro de Apoyo</th>
                    <td>{{ driver.center | master : "CENTERS" }}</td>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-6">
    <app-documents></app-documents>
  </div>
</div>
<div class="text-center my-5" *ngIf="isUploadingDocuments">
  <app-spinner
    message="Subiendo documentos a la nube, por favor espere"
  ></app-spinner>
</div>

<!-- Modals -->
<ng-template #driverModal let-c="close" let-d="dismiss">
  <app-modal-with-comment
    [modalTitle]="modalTitle"
    [modalQuestion]="modalQuestion"
    [modalMessage]="modalMessage"
    [showCommentForm]="modalWithComment"
    [mandatoryComment]="isBeingRejected"
    [commentForm]="commentForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-with-comment>
</ng-template>
<ng-template #excludeModal let-c="close" let-d="dismiss">
  <app-modal-with-select
    [modalTitle]="modalExcludeTitle"
    [modalQuestion]="modalExcludeQuestion"
    [modalMessage]="modalExcludeMessage"
    [showCommentForm]="modalExcludeComment"
    [commentForm]="commentExcludeForm"
    (modalDismissed)="d($event)"
    (modalClosed)="c($event)"
  ></app-modal-with-select>
</ng-template>
